// Notification chime with a user-gesture-unlocked AudioContext so a sound can
// play even when the app is in an idle/background tab (bypasses autoplay rules).
let ctx = null;
let unlocked = false;

function getCtx() {
  if (!ctx) {
    const AC = window.AudioContext || window.webkitAudioContext;
    if (AC) ctx = new AC();
  }
  return ctx;
}

// Call from a real user gesture (login click, sealing, first interaction).
export function unlockAudio() {
  const c = getCtx();
  if (!c) return;
  if (c.state === "suspended") c.resume().catch(() => {});
  unlocked = true;
}

export function isAudioUnlocked() {
  return unlocked;
}

// Short two-note chime (A5 → D6) synthesized in-browser, no asset needed.
export function playChime() {
  const c = getCtx();
  if (!c) return;
  if (c.state === "suspended") c.resume().catch(() => {});
  try {
    const now = c.currentTime;
    [
      [880.0, now],
      [1174.66, now + 0.13],
    ].forEach(([freq, start]) => {
      const osc = c.createOscillator();
      const gain = c.createGain();
      osc.type = "sine";
      osc.frequency.value = freq;
      gain.gain.setValueAtTime(0.0001, start);
      gain.gain.exponentialRampToValueAtTime(0.28, start + 0.02);
      gain.gain.exponentialRampToValueAtTime(0.0001, start + 0.36);
      osc.connect(gain);
      gain.connect(c.destination);
      osc.start(start);
      osc.stop(start + 0.42);
    });
  } catch (e) {
    /* ignore playback failures */
  }
}
